// HELPERS
import { useMakeRequest, useMutativeRequest } from '@/hooks'

// CONSTANTS
import { routes } from '../../constants'

// TYPES
import { AccountCompletionResponse, PhotoValidationResponse } from './types'

/**
 * Validate business assets, such as photos
 */
export function useAssetValidation() {
  return useMutativeRequest<PhotoValidationResponse>(
    routes.VALIDATE_BUSINESS_ASSETS_API,
  )
}

/**
 * Invoke growthnodeserv to validate that the account is complete and
 * allowed to create a profile
 */
export function useAccountCompletionValidation() {
  return useMakeRequest<AccountCompletionResponse>(
    routes.VALIDATE_ACCOUNT_COMPLETION_API,
  )
}
